// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"94":"Login","103":"ASR","218":"Logs","305":"Setting","561":"Dashboard","815":"Audio File to Text"}[chunkId] || chunkId) + "." + {"94":"3190c34e","103":"4746382c","218":"6aa7abd3","305":"dda99c0e","561":"f3745f20","730":"0bbc8b6c","815":"18f3b3f1"}[chunkId] + ".css";
};